module.exports = __webpack_public_path__ + "static/media/img-3.9100459f.jpg";